<template>
  <div class="mob-footer">
      <div class="menu-tab">
          <!-- <mob-menu :menuData="itemMob" menuEle="mob-footer"></mob-menu> -->
          <div class="mis-code">
              <div class="code-left">
                  <img src="@/assets/image/mob/gongzonghao.png" alt="code1">
                  <span>微信识别二维码关注微信公众号</span>
              </div>
              <div class="code-right">
                  <img src="@/assets/image/mob/douyin.png" alt="code2">
                  <span>抖音识别二维码关注抖音号</span>
              </div>
          </div>
          <div class="copy-right">
              <div class="copy-title">@大汉控股集团有限公司   网站备案:湘IP备2020017936</div>
              <div class="copy-desc">
                    <span>湘公安备43010202001100号</span>
                    <span class="divi"></span>
                    <a href="#">联系我们</a>
                    <a href="#">法律声明</a>
                    <a href="#">隐私保护</a>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { itemMob } from '../assets/mobJson'
import MobMenu from './MobMenu'
export default {
  name: 'MobHeader',
  components: {
    MobMenu
  },
  data () {
    return {
      itemMob
    }
  }
}
</script>

<style lang="less" scoped>
.mob-footer{
    .menu-tab{
        background: #333333;
    }
    .mis-code{
        display: flex;
        font-size: .3rem;
        color: #999999;
        line-height: .42rem;
        justify-content: space-between;
        text-align: center;
        padding: 1.2rem .73rem;
        .code-left{
            width: 2.4rem;
            img{
                display: block;
                width: 100%;
                margin-bottom: .2rem;
            }
        }
        .code-right{
            width: 2.4rem;
            img{
                display: block;
                width: 100%;
                margin-bottom: .2rem;
            }
        }
    }
    .copy-right{
        font-size: .2rem;
        color: #999999;
        line-height: .28rem;
        text-align: center;
        padding: .4rem 0;
        border-top: 1px solid rgba(255,255,255,0.15);
        .copy-desc{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: .1rem;
            .divi{
                width: .01rem;
                height: .28rem;
                background-color: #999999;
                margin: 0 .2rem;
            }
            a{
                color: #999999;
                margin-right: .2rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MobFooter.vue